import { Component, OnInit } from '@angular/core';
import { NavBarService } from '../../../../services/nav-bar.service';
import { IconBarService } from '../../../../services/icon-bar.service';
import { MenuService } from '../../../../services/menu.service';
import { BaseDisplayComponent } from '../../base-display/base-display.component';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuNode } from '../../../../classes';
@Component({
	selector: 'app-energiedaten',
	templateUrl: './energiedaten.component.html',
	styleUrls: ['./energiedaten.component.scss']
})
export class EnergiedatenComponent implements OnInit {
	_bigLetters:string="";
	_data = {
			'heating_gas':[
				{
					'l':'GAS',
					'u':'kWh/d',
					'v':0,
					'scales':[24],
					'scaletype':'pressure'
				},
				{
					'l':'GAS',
					'u':'kWh/d',
					'v':0,
					'scales':[23],
					'scaletype':'pressure'
				},
				{
					'l':'GAS',
					'u':'kWh',
					'v':17,
					'scales':[18,19,20,21,22,23],
					'scaletype':'pressure'
				},
				{
					'l':'GAS',
					'u':'kWh',
					'v':531,
					'scales':[10,11,12,13,14,15,16,17,18,19,20,21,22,23],
					'scaletype':'pressure'
				},
				{
					'l':'GAS',
					'u':'kWh',
					'v':1369,
					'scales':[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
					'scaletype':'pressure'
				}
			],
			'dhw_gas':[
				{
					'l':'GAS',
					'u':'kWh/d',
					'v':0,
					'scales':[24],
					'scaletype':'pressure'
				},
				{
					'l':'GAS',
					'u':'kWh/d',
					'v':0,
					'scales':[23],
					'scaletype':'pressure'
				},
				{
					'l':'GAS',
					'u':'kWh',
					'v':20,
					'scales':[19,20,21,22,23],
					'scaletype':'pressure'
				},
				{
					'l':'GAS',
					'u':'kWh',
					'v':637,
					'scales':[10,11,12,13,14,15,16,17,18,19,20,21,22,23],
					'scaletype':'pressure'
				},
				{
					'l':'GAS',
					'u':'kWh',
					'v':1643,
					'scales':[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19],
					'scaletype':'pressure'
				}
			],
			'heating_el':[
				{
					'l':'EL',
					'u':'kWh/d',
					'v':0,
					'scales':[24],
					'scaletype':'pressure'
				},
				{
					'l':'EL',
					'u':'kWh/d',
					'v':0,
					'scales':[23],
					'scaletype':'pressure'
				},
				{
					'l':'EL',
					'u':'kWh',
					'v':4,
					'scales':[19,20,21,22,23],
					'scaletype':'pressure'
				},
				{
					'l':'EL',
					'u':'kWh',
					'v':132,
					'scales':[10,11,12,13,14,15,16,17,18,19,20,21,22,23],
					'scaletype':'pressure'
				},
				{
					'l':'EL',
					'u':'kWh',
					'v':438,
					'scales':[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
					'scaletype':'pressure'
				}
			],
			'dhw_el':[
				{
					'l':'EL',
					'u':'kWh/d',
					'v':0,
					'scales':[24],
					'scaletype':'pressure'
				},
				{
					'l':'EL',
					'u':'kWh/d',
					'v':0,
					'scales':[23],
					'scaletype':'pressure'
				},
				{
					'l':'EL',
					'u':'kWh',
					'v':5,
					'scales':[19,20,21,22,23],
					'scaletype':'pressure'
				},
				{
					'l':'EL',
					'u':'kWh',
					'v':159,
					'scales':[10,11,12,13,14,15,16,17,18,19,20,21,22,23],
					'scaletype':'pressure'
				},
				{
					'l':'EL',
					'u':'kWh',
					'v':525,
					'scales':[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19],
					'scaletype':'pressure'
				}
			]
		}
	b():string{
		if(this._loading){
			return '';
		}
		return this._bigLetters;
	}

	_smallLetters:string="";
	s():string{
		if(this._loading){
			return '';
		}
		
		return this._smallLetters;
	}
	_unit : string = "";

	unit():string{
		if(this._loading){
			return '';
		}
		
		return this._unit;
	}
	constructor(
		private navBar:NavBarService,
		private iconBar:IconBarService,
		private menuService:MenuService,
		private ioService:DataIoService
		) {
	}

	subscription:any=undefined;
	node:MenuNode=undefined;
	ngOnInit() {
		this.node = this.menuService.getCurrentNode();
		this.iconBar.saveState('energiedaten');
		this.iconBar.disableAll();
		this.navBar.disableAll();
		this._loading = true;
		setTimeout(()=>{
			this._loading = false;
			this.updateDisplay();
		},5000);
		if(this.node.getIdentifier() == 'fachhandwerker-codeabfrage'){
			this.navBar.enableAll();
			this.navBar.blink('installer');
		}

		this.subscription = this.ioService.inputs.events$.subscribe(
			(event)=>{
				this.handler(event);
			}
		);
	}

	showScale(){
		return true;
	}

	_loading : boolean = true;
	isLoading(){
		return this._loading;
	}

	handler(event){
		switch(event){
			case 'up':{
				this.nextItem();
				return;
			}
			case 'down':{
				this.previousItem();
				return;
			}
			case 'confirm':{
				return;
			}
			case 'menu':{
				this.nextBlock();
				return;
			}
			case 'back':{
				this.menuService.goto('fachhandwerker-codeabfrage');
				return;
			}
			default:{
				return;
			}
		}
	}
	_currentBlock='heating_gas';
	_currentItem=0;
	nextItem(){
		let block = this._data[this._currentBlock];
		let length = block.length;
		let idx = this._currentItem;
		idx++;
		if(idx >= length){
			idx = length -1;
		}
		this._currentItem = idx;
		this.updateDisplay();
	}
	previousItem(){
		let block = this._data[this._currentBlock];
		let length = block.length;
		let idx = this._currentItem;
		idx--;
		if(idx < 0){
			idx = 0;
		}
		this._currentItem = idx;
		this.updateDisplay();
	}
	nextBlock(){
		this._currentItem = 0;
		switch(this._currentBlock){
			case 'heating_gas':{
				this._currentBlock = 'dhw_gas';
				this.updateDisplay();
				return;
			}
			case 'dhw_gas':{
				this._currentBlock = 'heating_el';
				this.updateDisplay();
				return;
			}
			case 'heating_el':{
				this._currentBlock = 'dhw_el';
				this.updateDisplay();
				return;
			}
			case 'dhw_el':{
				this.menuService.goto('fachhandwerker-codeabfrage');
				return;
			}
		}

	}
	updateDisplay(){

		this._smallLetters = this._data[this._currentBlock][this._currentItem]['l']+"";
		this._bigLetters = this._data[this._currentBlock][this._currentItem]['v']+"";

		let unit = this._data[this._currentBlock][this._currentItem]['u'];

		this._scaleType = this._data[this._currentBlock][this._currentItem]['scaletype'];
		this._scaleElements = new Array<number>(48);

		let scale = this._data[this._currentBlock][this._currentItem]['scales'];

		for(let i=0;i<scale.length; i++){
			this._scaleElements[scale[i]]=1;
		}

		if(unit == 'kWh/d'){
			this._unit = 'AICI_UNIT_KWHD';
		}

		if(unit == 'kWh'){
			this._unit = 'AICI_UNIT_KWH';
		}

		if(this._currentBlock.startsWith('heating')){
			console.log("enabling 'heating'");
			this.iconBar.enableIcon('heating');
			console.log("disabling 'dhw'");
			this.iconBar.disableIcon('dhw');

		}else{

			this.iconBar.enableIcon('dhw');
			this.iconBar.disableIcon('heating');

		}
	}
	_scaleElements:Array<number>;
	scaleElements():Array<number>{
		return this._scaleElements;
	}
	
	_scaleType:string='pressure';
	getScaleType():string{
		if(this._loading){
			return 'loadinganimation';
		}
		return this._scaleType;
	}

	ngOnDestroy(){
		this.iconBar.restoreState('energiedaten');
		if(this.subscription){
			this.subscription.unsubscribe();
		}
	}
}
